export const SCORING_METHOD_LABELS = {
  endbyend: 'End by End',
  inputfinalscore: 'Input Final Score',
  inputtotals: 'Manual Input (Totals Only)',
  both: 'Both'
};

// Methods offered by the quick game creator ('both' is a legacy event value).
export const QUICK_GAME_SCORING_METHODS = ['endbyend', 'inputfinalscore', 'inputtotals'];

export const SCORING_METHOD_DESCRIPTIONS = {
  endbyend: 'Score every end as it happens.',
  inputfinalscore: 'Enter the final score per set/skin.',
  inputtotals: 'Enter total shots and total game points only.'
};
